export default __webpack_public_path__ + "static/media/358.8e886420.png";